import React from 'react'

const IconLabel = ({
    icon,
    children,
    size=25,
    color
}) => {
    const Icon = icon
    return (
        <div style={{ display: 'flex', alignItems: 'center'}}>
            <div><Icon size={size} /></div>
            <div style={{ paddingLeft: '10px', color }}>{children}</div>
        </div>
    )
}

export default IconLabel